import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paginationRoot: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'flex-end',
    minWidth: '100%',
    margin: '20px 0 0',
    flexWrap: 'wrap',
    '& p': {
      fontSize: '15px',
      fontWeight: '500',
      color: '#838383',
      margin: '0 0 15px 0',
      [theme.breakpoints.down('640')]: {
        margin: '0 6px 15px 0',
      },
      [theme.breakpoints.down('480')]: {
        margin: '0 0 15px 0',
      },
    },
    [theme.breakpoints.down('768')]: {
      padding: '0',
    },
  },
  paginatorOuter: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 0 0 15px',
    margin: '0',
    userSelect: 'none',
    [theme.breakpoints.down('1024')]: {
      padding: 0,
    },
    [theme.breakpoints.down('768')]: {
      padding: '0 0 0 15px',
      margin: '0',
    },
    [theme.breakpoints.down('640')]: {
      padding: '0 6px 0 0',
      width: '100%',
    },
    [theme.breakpoints.down('480')]: {
      padding: '0',
      margin: '0',
      width: '100%',
    },
    '& li': {
      cursor: 'pointer',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#dee0e3',
      borderRadius: '4px',
      margin: 2,
      fontFamily: 'Rubik',
      fontSize: '14px',
      fontWeight: '500',
      display: 'inline-block',
      minWidth: '40px',
      height: '40px',
      lineHeight: '40px',
      [theme.breakpoints.down('1024')]: {
        minWidth: '36px',
        height: '36px',
        lineHeight: '36px',
      },
      '&:firstChild': {
        color: '#838383',
        backgroundColor: 'white',
      },
      '&:lastChild': {
        color: '#838383',
        backgroundColor: 'white',
      },
    },
  },
  inactivePage: {
    color: '#231f20',
    backgroundColor: '#ffffff',
  },
  activePage: {
    color: '#ffffff',
    backgroundColor: '#00bcb5',
  },
})

const Paginator = props => {
  const { pageSize, totalItems, activePage, numLinks, classes } = props
  const totalPages = Math.ceil(totalItems / pageSize)
  const max = totalPages < numLinks ? totalPages : numLinks
  const middle = Math.floor(max / 2)
  let from

  if (max < 2) {
    return null
  }

  if (activePage <= middle) {
    from = 1
  } else {
    if (activePage > totalPages - middle) {
      from = totalPages - max + 1
    } else {
      from = activePage - middle
    }
  }

  let links = []
  for (let i = 0; i < max; i++) {
    links.push(from + i)
  }
  const left = (
    <li
      style={{
        pointerEvents: activePage === 1 ? 'none' : 'auto',
        opacity: activePage === 1 ? '0.5' : '1',
      }}
      key={'left'}
      disabled={activePage === 1}
      onClick={() => props.onSelect(activePage - 1)}>
      {'<'}
    </li>
  )
  const buttons = links.map((l, i) => (
    <li className={`${l === activePage ? classes.activePage : classes.inactivePage}`} key={`page_${i}`} onClick={() => props.onSelect(l)}>
      {l}
    </li>
  ))
  const right = (
    <li
      style={{
        pointerEvents: activePage === totalPages ? 'none' : 'auto',
        opacity: activePage === totalPages ? '0.5' : '1',
      }}
      key={'right'}
      disabled={activePage === totalPages}
      onClick={() => props.onSelect(activePage + 1)}>
      {'>'}
    </li>
  )

  return (
    <div className={`${classes.root} ${classes.paginationRoot}`}>
      <p>
        <span>{(activePage - 1) * pageSize + 1}</span>-
        <span>{activePage * pageSize > totalItems ? totalItems : activePage * pageSize} </span>
        of
        <span> {totalItems}</span>
      </p>
      <ul className={classes.paginatorOuter}>
        {left}
        {buttons}
        {right}
      </ul>
    </div>
  )
}

export default withStyles(styles)(Paginator)



// WEBPACK FOOTER //
// ./src/components/Paginator.js